var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tdesign:money"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.6165 34.6327C29.5287 34.6327 27.5264 35.4621 26.05 36.9384C24.5737 38.4147 23.7443 40.417 23.7443 42.5049C23.7443 44.5927 24.5737 46.595 26.05 48.0713C27.5264 49.5476 29.5287 50.377 31.6165 50.377C33.7043 50.377 35.7067 49.5476 37.183 48.0713C38.6593 46.595 39.4887 44.5927 39.4887 42.5049C39.4887 40.417 38.6593 38.4147 37.183 36.9384C35.7067 35.4621 33.7043 34.6327 31.6165 34.6327ZM28.2427 42.5049C28.2427 41.6101 28.5982 40.7519 29.2309 40.1192C29.8636 39.4865 30.7217 39.1311 31.6165 39.1311C32.5113 39.1311 33.3694 39.4865 34.0021 40.1192C34.6348 40.7519 34.9903 41.6101 34.9903 42.5049C34.9903 43.3996 34.6348 44.2578 34.0021 44.8905C33.3694 45.5232 32.5113 45.8786 31.6165 45.8786C30.7217 45.8786 29.8636 45.5232 29.2309 44.8905C28.5982 44.2578 28.2427 43.3996 28.2427 42.5049Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.0455 18.0246L36.8954 8L10.6046 29.003L9.14709 28.9872V29.0097H8V56H55.233V29.0097H53.0693L48.7644 16.4165L44.0455 18.0246ZM48.3168 29.0097H25.7619L42.5611 23.2833L45.9844 22.1879L48.3168 29.0097ZM39.6011 19.5406L22.2599 25.4515L35.9934 14.4799L39.6011 19.5406ZM12.4984 47.3833V37.6219C13.4473 37.2856 14.3092 36.7418 15.0213 36.0301C15.7334 35.3184 16.2776 34.4568 16.6144 33.5081H46.6186C46.9553 34.4572 47.4994 35.3192 48.2115 36.0312C48.9236 36.7433 49.7856 37.2875 50.7346 37.6241V47.3856C49.7856 47.7222 48.9236 48.2664 48.2115 48.9785C47.4994 49.6905 46.9553 50.5525 46.6186 51.5016H16.6189C16.2819 50.5517 15.7371 49.6891 15.0243 48.9766C14.3114 48.2641 13.4484 47.7198 12.4984 47.3833Z",
    fill: "#0A0A0A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.aae1082f9bf8b9021d026c1a9b8bcaa4.svg";
export { ForwardRef as ReactComponent };